/** @module AQL/Defect/NewFIDefect */
define([
	"dojo/_base/declare",
	"csi/table/NewSaveOnly",
	"csi/xml"
], function(declare, NewSaveOnly, xml) {

	return declare(NewSaveOnly, {
		/**
		 * @override
		 * Adding ErrorType to the call
		 */
		_writeRequestParameters: function(call) {
			call.addParameter("ErrorType", xml.ATTR_REF, this.m_formData.getFieldValue("BatchErrorType"));
			this.inherited(arguments);
		}
	});
});